'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _Select = require('../inputs/Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyle(_ref) {
  var ok = _ref.ok;

  if (!ok) return { color: 'red' };
  return {};
}

function StreamData(props) {
  var onDropAccepted = props.onDropAccepted,
      upload = props.upload,
      download = props.download,
      file = props.file,
      modelOptions = props.modelOptions,
      modelName = props.modelName,
      setModelName = props.setModelName,
      result = props.result;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h1',
      null,
      'StreamData'
    ),
    _react2.default.createElement(
      _reactDropzone2.default,
      { onDropAccepted: onDropAccepted },
      file && file.name
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_Select2.default, { options: modelOptions, value: modelName, onChange: setModelName })
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'button',
        { onClick: upload },
        'Import'
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'button',
        { onClick: download },
        'Export'
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      result.map(function (_ref2, index) {
        var ok = _ref2.ok,
            message = _ref2.message;
        return _react2.default.createElement(
          'div',
          { key: index, style: getStyle({ ok: ok }) },
          message
        );
      })
    )
  );
}
StreamData.propTypes = {
  onDropAccepted: _propTypes.func,
  upload: _propTypes.func,
  download: _propTypes.func,
  file: _propTypes.object,
  modelOptions: _propTypes.array,
  modelName: _propTypes.string,
  setModelName: _propTypes.func,
  result: _propTypes.array
};

exports.default = StreamData;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/StreamData/StreamData.js
// module id = 1742
// module chunks = 0